<template>
  <div id="project.id" class="project" @click="show">
    <figure class="snip">
      <img :src="project.imageURL" :alt="project.title" />
      <figcaption>
        <h3>{{ project.title }}</h3>
        <p>
          {{ project.description }}
          <span @click="navigateToExternalURL(project.projectURL)">Details</span>
        </p>
      </figcaption>
    </figure>
  </div>
</template>

<script>
export default {
  name: "Project",
  props: ["project"],
  methods:{
    navigateToExternalURL (url){
      location.replace(url)
    }
  }
};
</script>